import React from 'react';
import { ImageWithFallback } from './figma/ImageWithFallback';

interface UserAvatarProps {
  src?: string | null;
  firstName?: string;
  lastName?: string;
  alt?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const sizeClasses = {
  xs: 'w-8 h-8 text-xs',
  sm: 'w-12 h-12 text-sm',
  md: 'w-16 h-16',
  lg: 'w-24 h-24 text-xl',
  xl: 'w-32 h-32 text-2xl'
};

export const UserAvatar: React.FC<UserAvatarProps> = ({
  src,
  firstName = '',
  lastName = '',
  alt,
  size = 'md',
  className = ''
}) => {
  const getInitials = () => {
    const first = firstName?.charAt(0)?.toUpperCase() || '';
    const last = lastName?.charAt(0)?.toUpperCase() || '';
    return first + last || '?';
  };

  const getBgColor = () => {
    const colors = [
      'bg-rose-500',
      'bg-pink-500',
      'bg-purple-500',
      'bg-indigo-500',
      'bg-blue-500',
      'bg-cyan-500',
      'bg-teal-500',
      'bg-green-500',
      'bg-amber-500',
      'bg-orange-500'
    ];
    
    const name = `${firstName}${lastName}`;
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
  };

  if (src) {
    return (
      <ImageWithFallback
        src={src}
        alt={alt || `${firstName} ${lastName}`}
        className={`${sizeClasses[size]} rounded-full object-cover ${className}`}
      />
    );
  }

  return (
    <div
      className={`${sizeClasses[size]} rounded-full flex items-center justify-center text-white ${getBgColor()} ${className}`}
    >
      {getInitials()}
    </div>
  );
};
